import { Routes } from "@angular/router";

export const LOGISTICA_ROUTES = {
    OPERACION: {
        HOME: "operation-record-home"
    },
    GESTION_SLI: {
        ADUANA: {
            HOME: "management-aduana-home"
        },
        TRANSPORTE: {
            HOME: "management-transport-home",
            ZONE: "management-zone"
        },
        ALMACEN: {
            HOME: "management-warehouse-home"
        },
        OPERACIONES: {
            HOME: "management-operations-home"
        }
    }
}

export const LogisticaRoutes: Routes = [
    {
        path: LOGISTICA_ROUTES.OPERACION.HOME,
        loadComponent: () => import("./registro-operacion/presentacion/bandeja-registro-operacion/bandeja-registro-operacion.component").then(c => c.BandejaRegistroOperacionComponent)
    },
    {
        path: LOGISTICA_ROUTES.GESTION_SLI.ADUANA.HOME,
        loadComponent: () => import("./gestion-agenciamiento-aduana/presentacion/bandeja-gestion-agenciamiento-aduana/bandeja-gestion-agenciamiento-aduana.component").then(c => c.BandejaGestionAgenciamientoAduanaComponent)
    },
    {
        path: LOGISTICA_ROUTES.GESTION_SLI.TRANSPORTE.HOME,
        loadComponent: () => import("./gestion-transporte/presentacion/bandeja-gestion-transporte/bandeja-gestion-transporte.component").then(c => c.BandejaGestionTransporteComponent)
    },
    {
        path: LOGISTICA_ROUTES.GESTION_SLI.TRANSPORTE.ZONE,
        loadComponent: () => import("./gestion-transporte/presentacion/bandeja-zona-ruta/bandeja-zona-ruta.component").then(c => c.BandejaZonaRutaComponent)
    },
    {
        path: LOGISTICA_ROUTES.GESTION_SLI.OPERACIONES.HOME,
        loadComponent: () => import("./gestion-otros/presentacion/bandeja-gestion-operaciones/bandeja-gestion-operaciones.component").then(c => c.BandejaGestionOperacionesComponent)
    },
]